import { useEffect } from 'react';
import { CheckCircle2, MessageCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

export default function DemoSucesso() {
  const navigate = useNavigate();

  useEffect(() => {
    // Dispara o evento CompleteRegistration do Facebook Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'CompleteRegistration');
    }
  }, []);

  const handleWhatsApp = () => {
    const whatsappUrl = `https://wa.me/5511976121346?text=${encodeURIComponent(
      'Olá! Acabei de solicitar uma demo do Lyra RH e gostaria de tirar algumas dúvidas.'
    )}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/20 via-background to-secondary/20 p-4">
      <Button 
        variant="ghost" 
        size="sm"
        onClick={() => navigate('/')}
        className="absolute top-4 left-4 flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Voltar para início
      </Button>

      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <CheckCircle2 className="h-10 w-10 text-primary" />
          </div>
          <CardTitle className="text-2xl font-bold">Solicitação Enviada!</CardTitle>
          <CardDescription className="text-base">
            Recebemos suas informações com sucesso. Nossa equipe entrará em contato em breve.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg bg-muted/50 p-4 text-sm">
            <p className="font-medium mb-2">📧 Verifique seu e-mail</p>
            <p className="text-muted-foreground">
              Você receberá uma confirmação em breve com mais detalhes sobre a demo.
            </p>
          </div>

          <Button 
            size="lg" 
            className="w-full gap-2"
            onClick={handleWhatsApp}
          >
            <MessageCircle className="h-5 w-5" />
            Tirar dúvidas no WhatsApp
          </Button>

          <Button 
            variant="outline" 
            className="w-full"
            onClick={() => navigate('/')}
          >
            Voltar para página inicial
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
